const ACCESS_TOKEN = "accessToken"

export { ACCESS_TOKEN }
